<script>
    import httpService from '@/services/core/http.service';
    import AdminGrid from '@/components/shared/AdminGrid';
    import { DxColumn, DxItem } from 'devextreme-vue/data-grid';
    import modalService from '@/services/core/modal.service';
    import BillingModal from '@/components/modals/billingHistory/BillingModal';
    import ConfirmModal from '@/components/modals/ConfirmModal';

    export default {
        components: {
            AdminGrid,
            DxColumn,
            DxItem
        },
        data() {
            return {
                dataSource: httpService.getDxDataSource('company-billing-history/grid')
            };
        },
        methods: {
            generateBilling() {
                modalService.show(BillingModal, {
                    item: { companyId: this.$route.params.companyId },
                    onSuccess: () => {
                        this.$refs['grid-billing-history'].refresh();
                    }
                });
            },
            downloadReport(id) {
                httpService.downloadReport(`company-billing-history/${id}/download`).then();
            },
            remove(item) {
                modalService.show(ConfirmModal, {
                    title: 'Delete Billing',
                    msg: `Are you sure you want to DELETE billing?`,
                    btnTextOk: 'Delete',
                    onSuccess: () => {
                        const url = `company-billing-history/${item.id}`;
                        httpService.delete(url).then(() => {
                            this.$refs['grid-billing-history'].refresh();
                        });
                    }
                });
            },
            showBilling(item) {
                this.$router.push(`/company-billing-history/${item.id}`);
            }
        }
    };
</script>

<template>
    <div class="main-content-header">
        <h3>
            <i class="bi bi-receipt"></i>
            Company Billing History
        </h3>
    </div>
    <div class="main-content-body">
        <AdminGrid :data-source="dataSource" ref="grid-billing-history">
            <template #toolbar>
                <DxItem location="after" widget="dxButton" :options="{ text: 'Generate Billing', onClick: generateBilling }" />
            </template>
            <DxColumn data-field="id" data-type="number" sort-order="desc" />
            <DxColumn data-field="createdOn" caption="Created On" data-type="date" />
            <DxColumn data-field="automaticBilling" caption="Auto-billing" data-type="boolean" width="10%" />
            <DxColumn data-field="start" caption="From" data-type="date" />
            <DxColumn data-field="end" caption="To" data-type="date" />
            <DxColumn data-field="remarks" data-type="string" />
            <template #actions="{ item }">
                <button type="button" class="btn btn-link py-0 lh-1 text-success" title="Download" @click="downloadReport(item.data.id)">
                    <i class="bi bi-download"></i>
                </button>

                <button type="button" class="btn btn-link py-0 lh-1 text-success" title="Billing" @click="showBilling(item.data)">
                    <i class="bi bi-receipt"></i>
                </button>

                <button type="button" class="btn btn-link py-0 lh-1 text-danger" title="Delete" @click="remove(item.data)">
                    <i class="bi bi-trash"></i>
                </button>
            </template>
        </AdminGrid>
    </div>
</template>
